import React, { useEffect, useState, useContext, useMemo, useRef } from 'react'
import { useDispatch, batch } from 'react-redux'
import { isTouchDevice } from '../../utils'
import MapContext from './MapContext'
import { useTrailProfile } from '../../api'
import { useSpatialSearch } from '../../hooks'
import { setMapPin } from '../../slices/map' 
import { setProfilePin } from '../../slices/profile'

const SyncProfileControl = (props) => {
  const {route_id, trail_id } = props
  const map = useContext(MapContext)
  const dispatch = useDispatch()
  const resetPinOnTouch = useRef()
  const [mapLnglat, setMapLnglat] = useState(null)
  const profile = useTrailProfile({routeId: route_id, trailId: trail_id}, {skip: !trail_id})
  const {distance, elevation, time, lnglat} = useSpatialSearch(profile, mapLnglat, 1000 / map.getZoom()) || {}

  useEffect(() => {
    if (!map) return

    const mouseHandler = (e) => {
      setMapLnglat([e.lngLat.lng, e.lngLat.lat])
      if (isTouchDevice){
        clearTimeout(resetPinOnTouch.current)
        resetPinOnTouch.current = setTimeout(()=>{
          setMapLnglat(null)
        }, 5000)
      }
    }

    map.on('click', mouseHandler)
    if (!isTouchDevice){
        map.on('mousemove', mouseHandler)
    }

    return () => {
      if (!map || !mouseHandler) return
      map.off('click', mouseHandler) 
      if (!isTouchDevice) map.off('mousemove', mouseHandler)
    }

  }, [map])

  
 useEffect(()=>{
   let mapPin, profilePin
   if (distance) {
     mapPin = lnglat
     profilePin = [distance, elevation, time]
   }
   batch(() => {
     dispatch(setMapPin(mapPin))
     dispatch(setProfilePin(profilePin))
   })
  }, [distance, elevation, time, lnglat, dispatch])


  return null
}

export default SyncProfileControl
